import { VIEWER_VERSION_CHECK_URL } from "./check_version_data";
import BookData from '../book_data';

import { TOOLS } from "../toolbar/tools";
import { store } from '../../store';

export default class VersionManager {
    /**
     *
     * @type {VersionManager}
     * @memberof VersionManager
     */
    static #instance;

    version;

    constructor() {

    }

    static get Instance () {
        if(this.#instance == null) {
            this.#instance = new VersionManager();
        }
        return this.#instance;
    }
    /**
     * 
     * @returns {Promise<Boolean>} need update viewer
     */
    async checkViewerVersion() {
        const response = await fetch(VIEWER_VERSION_CHECK_URL);
        const data = await response.text();
        if(parseFloat(data) > this.version) {
            console.log(`need to update viewer", ${parseFloat(data)} > ${this.version}`);
            return true;
        }else {
            console.log(`no need to update viewer", ${parseFloat(data)} <= ${this.version}`);
            return false;
        }
    }
    /**
     * 
     * @returns {Promise<Boolean>} need update book
     */
    async checkBookVersion() {
        const response = await fetch(BookData.Instance.getOnlineBookVersionPath());
        const data = await response.text();
        if(parseFloat(data) > BookData.Instance.bookVersion) {
            console.log(`need to update book, ${parseFloat(data)} > ${BookData.Instance.bookVersion}`);
            return true;
        }else {
            console.log(`no need to update book, ${parseFloat(data)} <= ${BookData.Instance.bookVersion}`);
            return false;
        }
    }

    async checkNeedToUpdate() {
        Promise.all([this.checkBookVersion(), this.checkViewerVersion()]).then(values => {
            console.log("values::", values);
            if(values.indexOf(true) != -1) {
                console.log("need to update");
                store.setToolToggle(TOOLS.UPDATE.TOOL, true);
            }
        })
    }

    async setCurrentVersion() {
        const response = await fetch(BookData.Instance.getLocalViewerVersionPath());

        if(!response.ok) {
            console.error("error::", response.status, response.statusText);

            this.version = 1;

            throw new Error(response.status + response.statusText);
        }
        const data = await response.text();

        this.version = parseFloat(data);

        this.checkNeedToUpdate();
    }
}